import React from 'react';
import { Switch } from '@material-ui/core';

export default function FHESwitch(props) {
    return <Switch {...props} />;
}



// WEBPACK FOOTER //
// ./data/components/FHESwitch.js